var pnum = 1;;
var hasinitialized = false;
var theip = "0.0.0.0";


//document.addEventListener("DOMContentLoaded", function() {

// ==========================================================
// e-Fitter Initialization + Button Placement
// ==========================================================


function gfitterdata(_cmd) {
  var data = {};
  data.CompanyKey = 18;
  data.CupSize = -1;
  data.BodyShape = -1;
  data.Ntype = -1;
  data.PageRef = encodeURIComponent(jQuery(location).attr("pathname"));
  data.MeasureMiddle = 36;
  data.MeasureBelow = 35;
  data.Trans = _cmd;

  var params =
    "CompanyKey=" + data.CompanyKey +
    "&BodyShape=" + data.BodyShape +
    "&CupSize=" + data.CupSize +
    "&Ntype=" + data.Ntype +
    "&PageRef=" + data.PageRef +
    "&MeasureMiddle=" + data.MeasureMiddle +
    "&MeasureBelow=" + data.MeasureBelow +
    "&Trans=" + data.Trans;

  jQuery.ajax({
    async: !1,
    crossDomain: !0,
    type: "GET",
    contentType: "application/json; charset=utf-8",
    url: "https://fitter.thebreastformstore.com/WebService/FittingChartWizard.asmx/setParams?" + params,
    dataType: "jsonp",
    jsonpCallback: "jsonCallback",
    success: function(result) {
      console.log("==== FITTER INITIALIZED");
      if (_cmd === "INITIALIZE") {
        if (result.CanRun) {
          console.log("==== FITTER PRODUCT RUNNABLE", result.CanRun);
          fPlaceButton();
        } else {
          console.log("==== FITTER NOT AVAILABLE! - " + data.PageRef);
        }
      }
    },
    error: function(e) {
      console.log("==== FITTER INITIALIZE ERROR", e);
    }
  });
}

// ----------------------------------------------------------
// Place the ✨ e-Fitter ✨ button
// ----------------------------------------------------------
/*function fPlaceButton() {
  if ($('[data-open-psvi-key="PSVIObj4554"]').length) return; // avoid duplicates

  var targets = [
    'label[for="select-1"]',
    'a[href="#charttableData"]',
    '#reportSummary'
  ];

  var newLink = $(
    '<div id="psvi-efitterbut">' +
      '<span>✨</span> ' +
      '<a class="custom-chart-link" href="#" data-open-psvi-key="PSVIObj4554" style="text-decoration:none;color:#ff0099 !important;">e-Fitter</a> ' +
      '<span>✨</span>' +
    '</div>'
  );*/
     
 function fPlaceButton() {
  if ($('#psvi-efitterbut').length) return; // avoid duplicates

  var target = $('.product-info__block.product-info__block--sm.product-info__title');

  var newLink = $(
    '<div id="psvi-efitterbut">' +

      '<a href="#" ' +
         'data-open-psvi-key="PSVIObj4554" ' +
         'class="custom-chart-link" ' +
         'style="' +
            'display:inline-block;' +
            'text-decoration:none;' +
            'transition:all 0.2s ease;' +
         '">' +

          '<img ' +
            'src="https://cdn.shopify.com/s/files/1/0666/4758/8954/files/EFITTERWIDE_fa209fcd-0d78-41b0-b361-1b0d87ddfc91.svg?v=1780116361" ' +
            'alt="e-Fitter" ' +
            'style="' +
              'max-width:280px;' +
              'width:100%;' +
              'height:auto;' +
              'display:block;' +
            '">' +

      '</a>' +

    '</div>'
  );

  if (target.length) {
    target.first().after(newLink);
    console.log("==== FITTER PRODUCT BUTTON PLACED AFTER TITLE BLOCK");
  }
}



function fCheckPanel(pn) {
    pn == 1 ? (jQuery("._fPrev").attr("style", "display: none!important"), jQuery("div._fNavSep").attr("style", "display: none!important"), jQuery("div._fNavSep2").attr("style", "display: none!important"), jQuery("._fNavSubmit").attr("style", "display: none!important")) : pn == 3 ? (jQuery("._fNext").attr("style", "display: none!important"), jQuery("div._fNavSep").attr("style", "display: none!important"), jQuery("div._fNavSep2").attr("style", "display: block!important"), jQuery("._fNavSubmit").attr("style", "display: block!important")) : pn == 4 ? (jQuery("._fNext").attr("style", "display: none!important"), jQuery("div._fNavSep").attr("style", "display: none!important"), jQuery("._fNavSubmit").attr("style", "display: none!important"), jQuery("div._fNavSep2").attr("style", "display: none!important"), jQuery("#OutProductSize").text(""), jQuery("#OutBandSize").text(""), jQuery("#OutCup").text("")) : (jQuery("._fPrev").attr("style", "display: block!important"), jQuery("._fNext").attr("style", "display: block!important"), jQuery("div._fNavSep").attr("style", "display: block!important"), jQuery("div._fNavSep2").attr("style", "display: none!important"), jQuery("._fNavSubmit").attr("style", "display: none!important")), pn == 1 || pn == 4 ? jQuery("._fNavBut").attr("style", "padding-left: 103px!important") : jQuery("._fNavBut").attr("style", "padding-left: initial!important");
    for (var i = 1; i <= 4; i++) i == pn ? jQuery("#_fStep" + i).attr("style", "display: block!important") : jQuery("#_fStep" + i).attr("style", "display: none!important")
}